import React from "react";

const Hero = () => {
  return (
    <section className="hero" id="hero">
      <div className="hero-overlay"></div>
      <div className="hero-content">
        <div className="hero-main">
          <div className="hero-meta">
            <span className="hero-badge">Industrial Fuel Optimisation</span>
          </div>
          <h1>Micro 24 – Fuel Additive for Heavy‑Duty Industry</h1>
          <p>
            A legacy industrial formulation engineered to dissolve sludge, clean up combustion,
            stabilise boilers and reclaim wasted fuel – without re‑engineering
            your existing systems.
          </p>
          <div className="hero-meta">
            <div className="hero-kpis">
              <div className="hero-kpi">
                <div className="hero-kpi-label">Smoke Reduction</div>
                <div className="hero-kpi-value">Up to 70%</div>
              </div>
              <div className="hero-kpi">
                <div className="hero-kpi-label">Overhaul Cycle</div>
                <div className="hero-kpi-value">1 → 3 months</div>
              </div>
              <div className="hero-kpi">
                <div className="hero-kpi-label">Experience</div>
                <div className="hero-kpi-value">33+ years</div>
              </div>
            </div>
          </div>
          <div>
            <a href="#contact" className="btn btn-primary">
              Request a Site Study
            </a>
            <a href="mailto:sales@micro24.com" className="btn btn-secondary">
              Talk to Engineering
            </a>
          </div>
        </div>
        <aside className="hero-aside">
          <div className="hero-aside-panel">
            <strong>Built for Performance & Energy Conservation</strong>
            <p>
              MICRO 24 has been deployed across forging units, power plants,
              dairies and SMEs – often in legacy boiler rooms with minimal
              instrumentation.
            </p>
          </div>
          <p className="hero-aside-note">
            Typical applications: diesel and furnace oil fired boilers, rotary
            furnaces, hot air generators, thermic fluid heaters and industrial
            ovens.
          </p>
        </aside>
      </div>
    </section>
  );
};

export default Hero;
